export class VertexPostalAddress {
   public addressLine1: string;
   public addressLine2: string;
   public city: string;
   public state: string;
   public county: string;
   public postalCode: string;
   public country: string;
   public userId: string;
}
